import React from 'react';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faHeart as faHeartSolid} from '@fortawesome/free-solid-svg-icons';
import { checkAuth, useAuthInfo } from '../../../lib/jwt';
import { convertCountsToFixedValue } from '../../../helpers/convertCountsToFixedValue';
import { ASSETS_BASE_URL } from '../../../lib/constants';

type LikesProps = {
  userReactions: { reaction: number }[],
  likesCount: number,
  size?: 'small' | 'medium' | 'large',
  isPanel?: boolean,
  onReacted?: () => any
};

export function Likes({ userReactions, likesCount, isPanel, size, onReacted: onLike }: LikesProps) {
  const router = useRouter();
  const isLikedByUser = userReactions?.some(t => t.reaction === 1);

  return (
    <div className="flex items-center">
      {isPanel ? (<img
        src={`${ASSETS_BASE_URL}system/cw-assets/heart.svg`}
        className={`cursor-pointer ${size === 'small' ? 'text-sm' : size === 'large' ? 'text-2xl' : 'text-lg'}`}
        onClick={() => checkAuth(() => onLike(), router)}
      />) : (<FontAwesomeIcon
        icon={isLikedByUser ? faHeartSolid : faHeart}
        className={`cursor-pointer ${isLikedByUser ? 'text-orange' : 'text-white'} ${size === 'small' ? 'text-sm' : size === 'large' ? 'text-2xl' : 'text-lg'}`}
        onClick={() => checkAuth(() => onLike(), router)}
      />)}
      <div className={`ml-2 text-sm ${size === 'large' ? 'text-base' : 'text-sm'}`}>
        {convertCountsToFixedValue(likesCount || 0)}
      </div>
    </div>
  )
}